import { nsModel } from "../../lib/namespace";

export const globalNS = nsModel("GLOBAL");
